import type { Environment } from './env.model';

export const environment = {
  url: 'https://www.energymarketprice.com',
  apiUrl: 'https://www.energymarketprice.com/siteapi',
  solutionsApiUrl: 'https://www.energymarketprice.com/EMPAPI/MenuQas',
  production: false,
  sso: {
    clientId: 'emp-admin-dashboard',
    issuer: 'https://sso.energymarketprice.com/',
  },
} as const satisfies Environment;
